"use strict";
$.ajaxSetup({
    xhrFields: {
        withCredentials: true
    },
    dataType: 'json'
});

var app = new Vue({
    el: '#quesUser',
    data: {
        is_coll: 0,
        list: 1,
        topList: 1,
        hasMore: true,
        // 触发开关，防止多次调用事件
        hasTopMore: true,
        topicData: [],
        //  列表
        kp_id: kp_id,
        rate: rate,
        isShow: false,
        isShowDe: false,
        comment_page: 0,
        link_id: 0,
        is_login: is_login,

        initialPage: 0,
        hasPrevious: true,
        hasNext: true,
        previousPage: 0,
        nextPage: 0,
        isLoading: false
    },
    created: function created() {
        this.requestList().done(res => {
            if (res.errno == 0) {
                this.topicData = res.data;
                this.nextPage = this.previousPage = this.initialPage = res.page;
                this.hasPrevious = res.page > 1;
                this.hasNext = res.data && res.data.length === 20;
                this.isLoading = false;
            } else {
                alert(res.msg);
            }
        })

    },
    mounted: function mounted() {
        var _this = this;

        if (sessionStorage.getItem('kp')) {
            _this.isShow = false;
            _this.isShowDe = true;
            _this.editor = EDITOR.init("ques_editor", 300, '请输入评论内容');
            $.ajax({
                type: 'get',
                url: API + '/app/comment/getpage/' + sessionStorage.getItem('kp'),
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).success(function (res) {
                _this.comment_page = res.data.page;
                _this.link_id = sessionStorage.getItem('kp');
                sessionStorage.removeItem('kp');
            });
        }

        $(window).on('scroll', function (e) {
            let scrollTop = $(this).scrollTop();
            let scrollHeight = Number($(document).height());
            let windowHeight = $(this).height(); // 此处是滚动条到底部时候触发的事件，在这里写要加载的数据，或者是拉动滚动条的操作

            if (Math.ceil(scrollTop + windowHeight) >= scrollHeight) {
                _this.requestNext();
            } else if (scrollTop == 0) {
                _this.requestPrevious()
            }
        });
    },
    methods: {
        coll: function coll(item) {
            if (item.is_coll == 0) {
                $.ajax({
                    url: '/Question/add_coll/type/1/ques_id/' + item.ques_id,
                    type: 'GET',
                    dataType: 'json'
                }).success(function (res) {
                    if (res.errno == 0 || res.errno == 200) {
                        alert_title('收藏成功');
                        item.is_coll = 1;
                    } else if (res.errno == 4013 || res.errno == 4030) {
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
                    } else {
                        alert(res.msg);
                    }
                });
            } else {
                $.ajax({
                    url: '/Question/del_coll/type/1/ques_id/' + item.ques_id,
                    type: 'GET',
                    dataType: 'json'
                }).success(function (res) {
                    if (res.errno == 0) {
                        alert_title('取消收藏');
                        item.is_coll = 0;
                    } else if (res.errno == 4013 || res.errno == 4030) {
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
                    } else {
                        alert(res.msg);
                    }
                });
            }
        },
        // 判断是否登录
        questionLogin: function questionLogin(id, kp_id) {
            if (!is_login) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            } else {
                window.open("/question/big/kp_id/" + kp_id + "/ques_id/" + id);
                // window.location.href = "/question/big/kp_id/" + kp_id + "/ques_id/" + id;
            }
        },
        // 判断是否加载
        loadmore: function loadmore(data) {
            var _this = this;

            var list = data;

            if (list.length == 0) {
                _this.hasMore = false;
            }
        },
        loadtopmore: function loadtopmore(data) {
            var _this = this;

            var list = data;

            if (list.page == 1) {
                _this.hasTopMore = false;
            }
        },
        // 答题列表
        questList: function questList() {
            var _this = this;

            if (!_this.hasMore) {
                return;
            }

            var uid = getCookie('uid');

            if (!uid) {
                // 未登录(不传页码) * 默认加载首页
                $.ajax({
                    type: 'get',
                    url: API + '/ques/qa?kp_id=' + this.kp_id,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).success(function (res) {
                    if (res.errno == ERROK) {
                        _this.topicData = res.data;
                        _this.initialPage = res.page;

                        if (res.page != '1') {
                            _this.list = res.page;
                        }

                        _this.topList = res.page;

                        _this.loadmore(res.data);

                        _this.loadtopmore(res);
                    }
                }).error(function () {
                });
            } else {
                // 登录情况，不传页码默认最后一次浏览的题目当前页
                $.ajax({
                    type: 'get',
                    url: API + '/ques/qa?kp_id=' + this.kp_id,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    }
                }).success(function (res) {
                    if (res.errno == ERROK) {
                        _this.topicData = res.data;

                        if (res.page != '1') {
                            _this.list = res.page;
                        }

                        _this.topList = res.page;

                        _this.loadmore(res.data);

                        _this.loadtopmore(res);
                    }
                }).error(function () {
                });
            }
        },
        requestList: function (page) {
            this.isLoading = true;
            let _page = page ? `&page=${page}` : '';
            return $.get(`${API}/ques/qa?kp_id=${this.kp_id}${_page}`).done(res => {
                if (res.errno == 0) {
                    this.hasNext = res.data && res.data.length == 20;
                }
            });
        },
        requestPrevious() {
            if (this.hasPrevious && !this.isLoading) {
                if (this.previousPage - 1 <= 0) {
                    this.hasPrevious = false;
                    return;
                }
                this.requestList((--this.previousPage)).done(res => {
                    if (res.errno == 0) {
                        this.topicData = res.data.concat(this.topicData);
                        this.isLoading = false;
                    } else {
                        alert(res.msg);
                    }
                });
            }
        },
        requestNext() {
            if (this.hasNext && !this.isLoading) {

                this.requestList(++this.nextPage).done(res => {
                    if (res.errno == 0) {

                        this.topicData = this.topicData.concat(res.data);
                        this.isLoading = false;
                    } else {
                        alert(res.msg)
                    }
                })
            }
        }
    }
});
